import { connect } from 'react-redux'
import { compose } from 'recompose'

import { signOut } from 'data/auth/actions'
import { makesMutations } from 'data/graphql'
import gql from 'graphql-tag'
import {
  createSuccessToasterMessage,
  createErrorToasterMessage,
} from 'data/ui/actions'

const providesDeleteOrganizationMutation = compose(
  connect(
    null,
    { signOut, createSuccessToasterMessage, createErrorToasterMessage }
  ),
  makesMutations({
    query: gql`
      mutation deleteOrganization {
        deleteOrganization
      }
    `,
    mutationPropName: 'deleteOrganization',
    getOnErrorFromProps: ({ createErrorToasterMessage }) => result => {
      createErrorToasterMessage({
        title: 'An error occured',
        detail: result.error.message,
      })
    },
    getOnResultFromProps: ({ signOut, createSuccessToasterMessage }) => () => {
      createSuccessToasterMessage({
        title: 'Your team will be deleted as soon as possible.',
        detail: `You will be automatically signed out in a few seconds.`,
      })
      setTimeout(() => {
        signOut({ redirectTo: 'https://slite.com' })
      }, 3000)
    },
  })
)

export default providesDeleteOrganizationMutation
